import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';
export interface BuyToneCSSStyle extends UIComponentCSSStyle
{
    getContentDivCSSStyle():object;
    getContentLabel1CSSStyle():object;
    getContentLabel2CSSStyle():object;
    getSubcriptionDivCSSStyle():object;
    getConfirmButtonCSSStyle(): object;
    getTermsConditionCSSStyle(): object;
    getRowDivCSSStyle():object;
    getMobileNumberCSSStyle(): object ;
    getMobileConfirmButtonCSSStyle():object;
    getAnchorCSSStyle(): object;

}

export class BuyToneCSSStyleImpl extends UIComponentCSSStyleImpl implements BuyToneCSSStyle
{
    
    getMobileNumberCSSStyle(): object 
    {
        return {
            marginTop: "40px",
            marginLeft:'31.5px',
            marginRight:'31.5px'
        };
    }
    getWrapperCSSStyle(): object
    {
        return {
            height: "auto",
            width: "100%",
            borderRadius: "8px",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            paddingBottom:'30px'

        };
    }


    getRowDivCSSStyle(): object 
    {
        return {
            marginTop: "20px",
            display: "flex",
            width:'100%',
            justifyContent:'center',
            position: "relative",
            alignItems:'center',
            flexDirection:"row",
            flexFlow: "row wrap",
        };
    }
    getContentDivCSSStyle(): object 
    {
        return{
            width:'227px',
            margin:'0px 106.5px 18px 106.5px',
            height:'60px',
            textAlign:'center' 
        };
    }
    getTermsConditionCSSStyle(): object {
        return{
            display: "inline-block",
            // textAlign: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? "left" : "right",
            height: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h7),
            color:'#231F20',
            fontWeight:'500',
            fontFamily:this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingLeft: "10px",
            // flex: 2,
            // paddingTop:'5px',
            // marginLeft:'5px',
        };
    }

    getContentLabel1CSSStyle(): object 
    {
        return{
            color:this.getResources().getColor(Colors.color_19),
            fontSize:this.getResources().getFont(Fonts.h9),
            textAlign:'center',
            lineHeight:'10px'
        };
    }

    getContentLabel2CSSStyle(): object 
    {
        return{
            color:this.getResources().getColor(Colors.color_21), 
            fontSize:this.getResources().getFont(Fonts.h10),
            textAlign:'center',
            fontWeight:500,
            lineHeight:'20px'
        };
    }

    getSubcriptionDivCSSStyle(): object 
    {
        return{
            width:"345px",
            color:this.getResources().getColor(Colors.color_22),
            fontFamily: this.getResources().getFontFamily(),
            margin:"0px 47.5px 0px 47.5px",
            fontSize:this.getResources().getFont(Fonts.h9), 
            fontWeight:500 ,
            height:'20px',
            lineHeight:'20px', 
            letterSpacing:'0',
            textAlign:'center'
        };
    }

    getConfirmButtonCSSStyle(): object 
    {
        return {
            marginTop: "30px",
            width:'180px',
            height: "40px",
            marginLeft: "auto",
            marginRight: "auto",
        };
    }

    getMobileConfirmButtonCSSStyle():object
    {
        return {
            marginTop: "30px",
            width:'100px',
            height: "40px",
            marginLeft: "auto",
            marginRight: "auto",
        };
    }
    getAnchorCSSStyle(): object {
        return {
                    lineHeight: '20px', 
                    letterSpacing: "-0.08px",
                    fontFamily: this.getResources().getFontFamily(), 
                    fontSize: this.getResources().getFont(Fonts.h6), 
                    color: this.getResources().getColor(Colors.color_7), 
                };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/buytone/buytonecss.tsx